import React, { FC } from "react";
import { Form, Input, DatePicker, Row, Col, Select } from "antd";

interface EchsAdmissionFormProps {
  form: any;
  loading?: boolean;
  disabled?: boolean;
  ageAboveSeventyWithoutReferral: boolean;
  ageBelowSeventyWithoutReferral: boolean;
}

const PreAuthEchsData: FC<EchsAdmissionFormProps> = ({
  form,
  disabled,
  ageAboveSeventyWithoutReferral,
  ageBelowSeventyWithoutReferral,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        PRE-AUTH & ADMISSION DATA
      </div>
      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%", padding: "0 15px" }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="polyClinic"
              label="POLYCLINIC"
              // rules={[
              //   {
              //     required: ageAboveSeventyWithoutReferral ? false : true,
              //     message: "Please Input Polyclinic",
              //   },
              // ]}
            >
              <Input
              disabled={disabled}
                // disabled={
                //   !(
                //     ageAboveSeventyWithoutReferral ||
                //     ageBelowSeventyWithoutReferral
                //   ) || disabled
                // }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="beneficiaryId"
              label="BENEFICIARY ID"
              rules={[
                { required: true, message: "Please input BENEFICIARY ID" },
              ]}
            >
              <Input
              disabled={disabled} 
              // disabled={true}
               />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="patientOpdIpdNumber"
              label="ADMISSION OPD NUMBER"
              rules={[
                {
                  required: true,
                  message: "Please input admission opd number",
                },
              ]}
            >
              <Input 
              // disabled={true}
              disabled={disabled} 
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="referralId"
              label="REFERRAL ID"
              rules={[
                {
                  required: ageAboveSeventyWithoutReferral ? false : true,
                  message: "Please input referral id",
                },
              ]}
            >
              <Input
              disabled={disabled}
                // disabled={
                //   !(
                //     ageAboveSeventyWithoutReferral ||
                //     ageBelowSeventyWithoutReferral
                //   ) || disabled
                // }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="serviceNumber"
              label="SERVICE NUMBER"
              rules={[
                {
                  required: ageAboveSeventyWithoutReferral ? false : true,
                  message: "please input service number",
                },
              ]}
            >
              <Input
                // disabled={
                //   !(
                //     ageAboveSeventyWithoutReferral ||
                //     ageBelowSeventyWithoutReferral
                //   ) || disabled
                // }
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="roomType"
              label="ROOM TYPE"
              rules={[{ required: false, message: "*" }]}
            >
              <Select placeholder="Select Room Type" disabled={disabled}>
                <Select.Option value="General">GENERAL</Select.Option>
                <Select.Option value="Private">PRIVATE</Select.Option>
                <Select.Option value="Semi-Private">SEMI PRIVATE</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="roomNumber"
              label="ROOM NUMBER"
              rules={[{ required: true, message: "Please input room number" }]}
            >
              <Input placeholder="ROOM NUMBER" disabled={disabled} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="approxTreatmentCost"
              label="APPROX TREATMENT COST"
              rules={[
                {
                  required: true,
                  message: "Please input approx treatment cost",
                },
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input placeholder="APPROX TREATMENT COST" disabled={disabled} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              name="opdDate"
              label="ADMISSION/OPD DATE/TIME"
              rules={[
                {
                  required: true,
                  message: "Please input admission opd date/time",
                },
              ]}
            >
              <DatePicker
                showTime
                format={dateFormat}
                style={{ width: "100%" }}
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              name="expectedDischargeDate"
              label="EXPECTED DISCHARGE DATE/TIME"
              rules={[
                {
                  required: true,
                  message: "Please input expected discharge date/time",
                },
              ]}
            >
              <DatePicker
                showTime
                format={dateFormat}
                style={{ width: "100%" }}
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              name="remarks"
              label="REMARKS"
              rules={[{ required: true, message: "Please input remarks" }]}
            >
              <Input placeholder="REMARKS" disabled={disabled} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default PreAuthEchsData;
